import React, { useState } from 'react';
import axios from 'axios';
import { Row, Col } from 'antd';
import querystring from 'query-string';
import {
  GlobalButton,
  IconImage,
  GlobalFormNewsletter,
  getNewsletterValues,
} from 'src/modules/global';
import { rowTextBlockProps } from 'src/utils/grid';
import classnames from 'classnames';
import { LayoutOverlay } from 'src/modules/layout';
import { useIntl, IntlShape } from 'react-intl';
import styles from './GlobalNewsletterButton.module.scss';
import { NewsletterPageTypes } from 'src/modules/pages/components/newsletter/PagesNewsletter';

export type OnFinishProps = {
  values: any;
  setError: (error: string) => void;
  intl: IntlShape;
  setSubmitSucess: (success: boolean) => void;
};

export const onFinishGlobalNewsletter = async ({
  values,
  setError,
  intl,
  setSubmitSucess,
}: OnFinishProps) => {
  try {
    const response = await axios.post(
      `${
        process.env.NEXT_PUBLIC_NEWSLETTER_API_URL || 'https://cloud.news.walterknoll.de'
      }/ctrl_register`,
      querystring.stringify({
        ...values,
        ...getNewsletterValues(values),
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    if (response.data?.Errors?.length) {
      setError(
        `${intl.formatMessage({ id: 'form/errorRegistration' })}: ${response.data?.Errors.join(
          '. '
        )}`
      );
    } else if (response.data?.Errors?.NL_Source_Website) {
      setError(
        `${intl.formatMessage({
          id: 'form/errorRegistration',
        })}: ${response.data?.Errors?.NL_Source_Website.join('. ')}`
      );
    } else {
      setError('');
      setSubmitSucess(true);
    }
  } catch (error) {
    // setSubmitSucess(true);
    setError(intl.formatMessage({ id: 'form/errorRegistration' }));
    error && console.error(error);
  }
};

export const GlobalNewsletterButton = ({ showInfoText = true }: { showInfoText?: boolean }) => {
  // const { outputChannel = OutputChannels.DE } = query;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [error, setError] = useState('');
  const [submitSucess, setSubmitSucess] = useState(false);
  const intl = useIntl();

  const handleClose = () => {
    setIsOpen(false);
    setSubmitSucess(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <div className={classnames(styles.container)}>
      <LayoutOverlay
        title="Subscribe to Newsletter"
        display={isOpen}
        onClose={handleClose}
        error={error}>
        {submitSucess ? (
          <Row {...rowTextBlockProps}>
            <Col xs={24} md={{ span: 12, offset: 6 }}>
              <div className={styles.success}>
                <h3>{intl.formatMessage({ id: 'form/successRegistration/title' })}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage({ id: 'form/successRegistration/subline' }),
                  }}
                />
              </div>
            </Col>
          </Row>
        ) : (
          <GlobalFormNewsletter
            onFinish={(values) =>
              onFinishGlobalNewsletter({ values, setError, intl, setSubmitSucess })
            }
            type={NewsletterPageTypes.Register}
            topMargin={true}
          />
        )}
      </LayoutOverlay>
      {showInfoText && (
        <>
          <div className={`${styles.text} ${styles.title}`}>
            {intl.formatMessage({ id: 'footer/newsletter/title' })}
          </div>
          <div className={styles.text}>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: 'footer/newsletter/description' }),
              }}
            />
          </div>
        </>
      )}
      <GlobalButton
        type="primary"
        widthType="fluid"
        labelSize="small"
        rightIconImage={IconImage.Link}
        onClick={handleOpen}
        className={styles.subscribeButton}>
        {intl.formatMessage({ id: 'footer/newsletter/subscribe' })}
      </GlobalButton>
    </div>
  );
};

export default GlobalNewsletterButton;
